<script setup lang="ts">
provideGameReset()
</script>

<template>
  <slot/>
  <GameFab/>
</template>
